import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'classesStudents.edit.addConfirmation.title',
    defaultMessage: 'CLASS ADDED',
  },
  subtitle: {
    id: 'classesStudents.edit.addConfirmation.subtitle',
    defaultMessage: 'Class was successfully added.',
  },
  continue: {
    id: 'classesStudents.edit.addConfirmation.continue',
    defaultMessage: 'Continue',
  },
});
